import { useState } from "react";

import { Outlet } from "react-router-dom";

import { Header } from "@/components/layout/header";
import { Sidebar } from "@/components/layout/sidebar";
import { cn } from "@/lib/utils";

export function AppShell() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="min-h-svh-safe bg-background">
      <Sidebar collapsed={collapsed} onToggleCollapsed={() => setCollapsed((v) => !v)} />
      <div
        className={cn(
          "min-h-svh-safe flex flex-col transition-[margin] duration-200",
          collapsed ? "md:ml-16" : "md:ml-64",
        )}
      >
        <Header />
        <main className="flex-1 p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
